// Oct 3 2026, user's report (lot 76437, POWDER COATING): confirming 1 EA
// needs 0.0025 KG of MAT, and the shared 2-decimal formatter rendered that
// as "0 KG" - a required quantity that reads as zero is worse than no
// number at all. Input requirements are per-unit fractions (powder, glue,
// coating), so they get 4 decimals, and anything still rounding to zero at
// 4 is widened until it shows a real figure.
export const formatInputQty = (v) => {
  if (v == null) return "—";
  if (v === 0) return "0";
  for (const digits of [4, 6, 8]) {
    const shown = v.toLocaleString("en-IN", { maximumFractionDigits: digits });
    if (parseFloat(shown.replace(/,/g, "")) !== 0) return shown;
  }
  return v.toExponential(2);
};

export default formatInputQty;
